var map = {
	"./clubs_10.png": 968,
	"./clubs_2.png": 3794,
	"./clubs_3.png": 467,
	"./clubs_4.png": 4790,
	"./clubs_5.png": 4981,
	"./clubs_6.png": 248,
	"./clubs_7.png": 9182,
	"./clubs_8.png": 7169,
	"./clubs_9.png": 2231,
	"./clubs_ace.png": 915,
	"./clubs_jack.png": 2573,
	"./clubs_king.png": 3241,
	"./clubs_queen.png": 8810,
	"./diamonds_10.png": 8210,
	"./diamonds_2.png": 756,
	"./diamonds_3.png": 4036,
	"./diamonds_4.png": 2842,
	"./diamonds_5.png": 8982,
	"./diamonds_6.png": 946,
	"./diamonds_7.png": 2879,
	"./diamonds_8.png": 5933,
	"./diamonds_9.png": 3752,
	"./diamonds_ace.png": 6650,
	"./diamonds_jack.png": 8362,
	"./diamonds_king.png": 3281,
	"./diamonds_queen.png": 5740,
	"./hearts_10.png": 7276,
	"./hearts_2.png": 665,
	"./hearts_3.png": 8309,
	"./hearts_4.png": 3104,
	"./hearts_5.png": 6757,
	"./hearts_6.png": 7738,
	"./hearts_7.png": 8179,
	"./hearts_8.png": 5105,
	"./hearts_9.png": 9422,
	"./hearts_ace.png": 6904,
	"./hearts_jack.png": 5787,
	"./hearts_king.png": 995,
	"./hearts_queen.png": 2134,
	"./joker_black.png": 5159,
	"./joker_red.png": 4328,
	"./spades_10.png": 3758,
	"./spades_2.png": 2846,
	"./spades_3.png": 2282,
	"./spades_4.png": 6717,
	"./spades_5.png": 6900,
	"./spades_6.png": 771,
	"./spades_7.png": 4691,
	"./spades_8.png": 3460,
	"./spades_9.png": 3051,
	"./spades_ace.png": 3826,
	"./spades_jack.png": 2417,
	"./spades_king.png": 3650,
	"./spades_queen.png": 310
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;